import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BodyComponent } from '@design-system/typography/body/body.component';
import { UnityBrandLockupComponent } from '../../branding/unity-brand-lockup/unity-brand-lockup.component';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BodyComponent, UnityBrandLockupComponent],
  standalone: true,
})
export class AuthLayoutComponent {
  @Input() showWide = false;
}


